//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import anger from '@/assets/icons/anger.png'
export default {
  props: ['title', 'content'],
  data () {
    return {
      anger: anger,
      downText: '查看全部',
      isDown: true
    }
  },
  methods: {
    switchOpen () {
      this.downText === '查看全部' ? this.downText = '收起' : this.downText = '查看全部'
      this.isDown = !this.isDown
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/clinic/intro.vue